import React from "react";
import { Container, Spinner } from "react-bootstrap";
import {
  FaTruckMoving,
  FaTractor,
  FaHardHat,
} from "react-icons/fa";

const Loading = () => {
  return (
    <div
      className="vh-100 d-flex align-items-center justify-content-center"
      style={{
        background: "#111",
      }}
    >
      <Container className="text-center">

      
        <div className="d-flex justify-content-center gap-4 mb-4">
          <FaTruckMoving
            size={42}
            style={{ color: "var(--primary-color)" }}
          />

          <FaTractor
            size={42}
            style={{ color: "var(--primary-color)" }}
          />

          <FaHardHat
            size={42}
            style={{ color: "var(--primary-color)" }}
          />
        </div>

  
        <h1
          className="display-2 fw-bold mb-3"
          style={{ letterSpacing: "3px" }}
        >
          <span style={{ color: "var(--primary-color)" }}>K</span>
          <span className="text-white">RIMOTION</span>
        </h1>

      
        <Spinner
          animation="border"
          style={{
            width: "4.5rem",
            height: "4.5rem",
            color: "var(--primary-color)",
            borderWidth: "6px",
          }}
        />

        {/* Text */}
        <h5 className="text-white mt-4 fw-semibold">
          Preparing Your Services...
        </h5>

        <p
          className="text-secondary mt-2"
          style={{ maxWidth: "500px", margin: "auto" }}
        >
          Please Wait While We Connecting Machines, People & Opportunities..
        </p>

        {/* Fake Progress Bar */}
        <div
          className="progress mt-4 mx-auto"
          style={{
            height: "8px",
            maxWidth: "320px",
            background: "#2b2b2b",
          }}
        >
          <div
            className="progress-bar progress-bar-striped progress-bar-animated"
            style={{
              width: "100%",
              background: "var(--primary-color)",
            }}
          ></div>
        </div>

      </Container>
    </div>
  );
};

export default Loading;